export class Viewbag {
    public value: any;
}
